/* Ronner Timeline — handles sequential line-fill animation + optional background parallax.
   Loaded once (cached by the browser) and initializes every .ronner-timeline instance on the page. */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLineAnimation(section) {
    if (section.dataset.animateLine !== 'true') return;

    var track = section.querySelector('.ronner-timeline__track');
    var fills = track ? track.querySelectorAll('.ronner-timeline__connector-fill') : [];
    if (!track || !fills.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < fills.length; i++) fills[i].classList.add('is-active');
      return;
    }

    function runSequentially(index) {
      if (index >= fills.length) return;
      var fill = fills[index];

      function onDone(e) {
        if (e.target !== fill) return;
        if (e.propertyName !== 'width' && e.propertyName !== 'height') return;
        fill.removeEventListener('transitionend', onDone);
        runSequentially(index + 1);
      }

      fill.addEventListener('transitionend', onDone);
      requestAnimationFrame(function () {
        fill.classList.add('is-active');
      });
    }

    var lineObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runSequentially(0);
            lineObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -10% 0px' }
    );

    lineObserver.observe(track);
  }

  function initParallax(section) {
    if (section.dataset.parallax !== 'true' || prefersReducedMotion) return;

    var bgImg = section.querySelector('.ronner-timeline__bg-img');
    if (!bgImg) return;

    var speed = parseFloat(section.dataset.parallaxSpeed) || 0.25;
    var ticking = false;

    function update() {
      var offset = (window.innerHeight - section.getBoundingClientRect().top) * speed * 0.35;
      bgImg.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    var bgObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          update();
          window.addEventListener('scroll', onScroll, { passive: true });
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    }, { threshold: 0 });

    bgObserver.observe(section);
  }

  function initSection(section) {
    if (section.dataset.rtInitialized === 'true') return;
    section.dataset.rtInitialized = 'true';
    initLineAnimation(section);
    initParallax(section);
  }

  function init() {
    var sections = document.querySelectorAll('.ronner-timeline');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a new instance of the section is added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ronner-timeline');
    if (section) initSection(section);
  });
})();
